import { render, staticRenderFns } from "./SendReceiptModal.vue?vue&type=template&id=8408e160&"
import script from "./SendReceiptModal.vue?vue&type=script&lang=js&"
export * from "./SendReceiptModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports